// extracted by mini-css-extract-plugin
module.exports = {"searchVerticalRecosContainer":"fT","productsContainer":"gT","searchVerticalReco":"hT","heading":"iT"};